// @core/api/endpoints/calendar/cancel_entity_schedule.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CalendarLifecycleResponse,
  CancelEntityScheduleRequest,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Cancel entity schedule
 * Cancels the schedule of any calendar-aware entity. Frees up availability and notifies relevant parties.
 */
export async function CancelEntitySchedule(
  target_type: string,
  target_id: string,
  data: CancelEntityScheduleRequest,
  options?: RequestOptions
): Promise<CalendarLifecycleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/calendar/:target_type/:target_id/cancel`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.post<CalendarLifecycleResponse>(requestPath, data, requestOptions);
}
